import { Box, Typography } from '@mui/material';

interface ElementProps {
  title: string;
  content: string;
  icon: string;
}

export const Element = ({ title, content, icon }: ElementProps) => {
  return (
    <Box display="flex" alignItems="center">
      <Box>
        <img src={icon} alt={title + ' ' + content} />
      </Box>
      <Box ml="20px">
        <Typography
          component="h4"
          fontWeight={900}
          fontSize={40}
          color="#004643"
          lineHeight="47px"
        >
          {title}
        </Typography>
        <Typography color="rgba(0, 0, 0, 0.6)" fontSize={24}>
          {content}
        </Typography>
      </Box>
    </Box>
  );
};
